import booleanReducer from '../../../../common/reducers/booleanReducer';
import { CLOSE_CHARGE_MODAL, OPEN_CHARGE_MODAL } from './constants';

const chargeModal = booleanReducer(
  false,
  [OPEN_CHARGE_MODAL],
  [CLOSE_CHARGE_MODAL]
);

export default chargeModal;
